import { createContextFunction } from '../utils/createContextFunction'

export const [IsHiddenProvider, useIsHidden] = createContextFunction<boolean>(
  'IsHidden',
  () => false,
)
